import { FieldValues, useController } from "react-hook-form"
import { ManagedPropsWithOptionalLabel } from "./type"
import React, { useId } from "react"
import { Form } from "react-bootstrap"

type Props<TFieldValues extends FieldValues, TContext = unknown, TTransformedValues = TFieldValues> = ManagedPropsWithOptionalLabel<TFieldValues, TContext, TTransformedValues> & {
  checkboxLabel: string
}

export function ManagedCheckbox<TFieldValues extends FieldValues, TContext = unknown, TTransformedValues = TFieldValues>({ control, name, label, checkboxLabel, helper, required }: Props<TFieldValues, TContext, TTransformedValues>) {
  const id = useId()
  const { field, fieldState } = useController({ name, control })

  return (
    <Form.Group controlId={id}>
      {
        label == null ? null : (
          <Form.Label>
            {label}
            {required ? <span className="text-danger">*</span> : null}
          </Form.Label>
        )
      }
      <Form.Check>
        <Form.Check.Input {...field} checked={field.value ?? false} />
        <Form.Check.Label>{checkboxLabel}</Form.Check.Label>
      </Form.Check>
      {fieldState.error ? <Form.Text className="text-danger">{fieldState.error.message}</Form.Text> : helper != null ? <Form.Text className="text-muted">{helper}</Form.Text> : null}
    </Form.Group>
  )
}
